import { render, staticRenderFns } from "./Match.vue?vue&type=template&id=31d432d6&scoped=true"
import script from "./Match.vue?vue&type=script&lang=js"
export * from "./Match.vue?vue&type=script&lang=js"
import style0 from "./Match.vue?vue&type=style&index=0&id=31d432d6&prod&scoped=true&lang=css"
import style1 from "./Match.vue?vue&type=style&index=1&id=31d432d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d432d6",
  null
  
)

export default component.exports